module.exports = {
  dataIndustry: [
    "游戏",
    "电子",
    "软件",
    "金融",
    "资产",
    "食品",
    "广告",
    "设计",
    "贸易",
    "实业",
    "制造",
    "服饰",
    "工程",
    "农业",
    "物流",
    "纺织",
    "造纸",
    "广播",
    "电视",
    "畜牧",
    "制糖",
    "制鞋",
    "印刷",
    "客运",
    "旅馆",
    "典当",
    "美容",
    "教育",
    "科技",
    "财税",
    "建设",
    "商贸",
    "网络",
    "传媒",
    "销售",
    "商务",
    "餐饮",
    "管理",
    "技术",
    "咨询",
    "养殖",
    "智能",
    "影视",
    "工贸",
    "化工",
    "物业",
    "医药",
    "材料",
    "家具",
    "家居",
    "建材",
    "资源",
    "设备",
    "机械",
    "机电",
    "货运",
    "金属",
    "租赁",
    "酒业",
    "烟草",
    "电器",
    "仪器",
    "婚庆",
    "药房",
    "商业",
    "美发",
    "服装",
    "投资",
    "展览",
    "会展",
    "新材料",
    "化妆品",
    "互联网",
    "纸制品",
    "酒制造",
    "大数据",
    "云计算",
    "物联网",
    "新贸易",
    "房地产",
    "新餐饮",
    "新物流",
    "新实业",
    "新服装",
    "日用品",
    "机动车",
    "新商贸",
    "网络科技",
    "电子商务",
    "信息技术",
    "生物科技",
    "教育科技",
    "投资管理",
    "商业保理",
    "融资租赁",
    "医疗器械",
    "人力资源",
    "劳务派遣",
    "文化传媒",
    "建筑装潢",
    "美容美发",
    "物业管理",
    "商务咨询",
    "企业管理",
    "餐饮管理",
    "信息科技",
    "环保科技",
    "人工智能",
    "智能制造",
    "电机制造",
    "设备制造",
    "知识产权",
    "电信服务",
    "软件开发",
    "呼叫中心",
    "机床制造",
    "律师服务",
    "法律服务",
    "海洋服务",
    "食品制造",
    "风机制造",
    "污染治理",
    "环保咨询",
    "轮胎制造",
    "家电制造",
    "数字出版",
    "电器制造",
    "广告服务",
    "牲畜饲养",
    "家禽饲养",
    "水产养殖",
    "内陆养殖",
    "牲畜屠宰",
    "禽类屠宰",
    "蔬菜加工",
    "白酒制造",
    "啤酒制造",
    "黄酒制造",
    "饮料制造",
    "服饰制造",
    "皮箱制造",
    "皮包制造",
    "木材加工",
    "家具制造",
    "文具制造",
    "玩具制造",
    "塑料制品",
    "模具制造",
    "眼镜制造",
    "电气安装",
    "建筑安装",
    "建筑装饰",
    "建筑装修",
    "住宅装饰",
    "住宅装修",
    "食品批发",
    "饮料批发",
    "服装批发",
    "鞋帽批发",
    "灯具批发",
    "建材批发",
    "贸易代理",
    "城市配送",
    "搬家运输",
    "家政服务",
    "通用仓储",
    "低温仓储",
    "快递服务",
    "旅游饭店",
    "民宿服务",
    "正餐服务",
    "快餐服务",
    "茶馆服务",
    "酒吧服务",
    "小吃服务",
    "汽车租赁",
    "健康咨询",
    "包装服务",
    "办公服务",
    "翻译服务",
    "家庭服务",
    "婚姻服务",
    "清洁服务",
    "宠物服务",
    "宠物饲养",
    "宠物美容",
    "技能培训",
    "文化艺术",
    "旅游培训",
    "长租公寓",
    "网络出版",
    "生态旅游",
    "体育旅游",
    "无人零售",
    "汽车金融",
    "税务科技",
    "财税咨询",
    "财税服务",
    "建筑工程",
    "教育咨询",
    "科技发展",
    "咨询服务",
    "文化发展",
    "咨询管理",
    "在线教育",
    "技术培训",
    "体育发展",
    "管理咨询",
    "医学教育",
    "建筑科学",
    "教育文化",
    "租赁服务",
    "建筑材料",
    "建筑设计",
    "建筑科技",
    "教育用品",
    "教育培训",
    "教育资源",
    "网络技术",
    "网络工程",
    "广告传媒",
    "广告设计",
    "广告制作",
    "图文广告",
    "广告材料",
    "广告传播",
    "国际贸易",
    "贸易发展",
    "食品贸易",
    "服装贸易",
    "钢铁贸易",
    "汽车贸易",
    "服饰贸易",
    "电子科技",
    "智能科技",
    "医疗科技",
    "文化传播",
    "影视文化",
    "文化创意",
    "体育文化",
    "影视传媒",
    "传媒科技",
    "网络传媒",
    "汽车销售",
    "食品销售",
    "建材销售",
    "家具销售",
    "电子设备",
    "电子技术",
    "电子工程",
    "电子材料",
    "电子仪器",
    "商务服务",
    "商务管理",
    "建设工程",
    "装饰工程",
    "工程机械",
    "机电工程",
    "信息咨询",
    "餐饮服务",
    "酒店管理",
    "健康管理",
    "机械制造",
    "阀门制造",
    "精密制造",
    "道具制造",
    "轴承制造",
    "生物技术",
    "工程技术",
    "汽车技术",
    "软件技术",
    "环保工程",
    "环保设备",
    "环保技术",
    "企业发展",
    "企业服务",
    "企业咨询",
    "旅游咨询",
    "仓储服务",
    "国际物流",
    "物流科技",
    "物流服务",
    "物流发展",
    "物流设备",
    "汽车物流",
    "物流管理",
    "物流咨询",
    "实业发展",
    "生活实业",
    "健康实业",
    "农业科技",
    "农业发展",
    "智能设备",
    "智能技术",
    "智能工程",
    "智能家居",
    "影视制作",
    "视觉科技",
    "影视传播",
    "视觉设备",
    "食品科技",
    "食品设备",
    "食品机械",
    "食品技术",
    "食品工业",
    "化工科技",
    "市政工程",
    "生物工程",
    "物业顾问",
    "物业服务",
    "物业投资",
    "图文设计",
    "创意设计",
    "装饰设计",
    "医疗咨询",
    "医疗设备",
    "医药科技",
    "医疗管理",
    "医疗技术",
    "生物医药",
    "纺织服饰",
    "服饰销售",
    "服饰发展",
    "儿童服务",
    "服装服饰",
    "服饰设计",
    "服饰科技",
    "针织服饰",
    "家居设计",
    "家居装饰",
    "服装销售",
    "材料科技",
    "建材装饰",
    "金属材料",
    "装饰材料",
    "包装材料",
    "办公家居",
    "家居用品",
    "家居服务",
    "建材科技",
    "新型建材",
    "装饰建材",
    "建材贸易",
    "人才咨询",
    "人才服务",
    "资源管理",
    "资源服务",
    "资源科技",
    "资源开发",
    "日用百货",
    "美容服务",
    "汽车美容",
    "软件销售",
    "软件设计",
    "科技开发",
    "旅游开发",
    "建设开发",
    "能源开发",
    "机械设备",
    "机电设备",
    "设备工程",
    "设备租赁",
    "安装工程",
    "机电安装",
    "机电科技",
    "机械科技",
    "货运代理",
    "国际货运",
    "精密机械",
    "建设发展",
    "金属贸易",
    "金属制品",
    "金属科技",
    "机械租赁",
    "房屋租赁",
    "印刷科技",
    "印刷制品",
    "包装印刷",
    "酒店用品",
    "酒店设备",
    "烟草糖酒",
    "影视科技",
    "商贸服务",
    "仪器设备",
    "精密仪器",
    "电器设备",
    "科学仪器",
    "仪器科技",
    "纺织科技",
    "纺织贸易",
    "纺织服务",
    "纺织服装",
    "艺术设计",
    "艺术发展",
    "国际商业",
    "商业道具",
    "商业发展",
    "婚庆服务",
    "婚庆礼仪",
    "投资咨询",
    "汽车服务",
    "汽车科技",
    "软件科技",
    "软件服务",
    "消防工程",
    "安防科技",
    "消防科技",
    "消防设备",
    "安防工程",
    "防腐科技",
    "医药咨询",
    "视觉艺术",
    "商业管理",
    "商业服务",
    "商业银行",
    "市场咨询",
    "金融服务",
    "金融控股",
    "美容科技",
    "美容咨询",
    "美容用品",
    "通信设备",
    "电气设备",
    "商贸发展",
    "国际商贸",
    "钟表商贸",
    "眼镜商贸",
    "服装设计",
    "服装科技",
    "股权投资",
    "创业投资",
    "展览服务",
    "展览工程",
    "展览设计",
    "服装商贸",
    "房地产中介",
    "发动机制造",
    "新能源汽车",
    "计算机制造",
    "互联网服务",
    "互联网平台",
    "试验机制造",
    "调味品制造",
    "水资源管理",
    "水产品加工",
    "豆制品制造",
    "食用冰制造",
    "葡萄酒制造",
    "肉制品加工",
    "刨花板制造",
    "纸制品制造",
    "化妆品制造",
    "水产品批发",
    "调味品批发",
    "农产品仓储",
    "咖啡馆服务",
    "房地产开发",
    "托儿所服务",
    "工艺品制造",
    "互联网支付",
    "互联网广告",
    "互联网教育",
    "互联网零售",
    "进出口贸易",
    "新材料科技",
    "新商务服务",
    "新商务咨询",
    "房地产经纪",
    "房地产咨询",
    "房地产顾问",
    "新餐饮管理",
    "新材料技术",
    "日用品销售",
    "日用品商业",
    "日用化妆品",
    "自动化设备",
    "计算机科技",
    "新金属材料",
    "新影视制作",
    "化妆品商贸",
    "互联网科技",
    "健康互联网",
    "日用品行业",
    "化妆品销售",
    "网络运营服务",
    "新兴软件开发",
    "海洋工程建筑",
    "生物饲料制造",
    "环保工程施工",
    "新型媒体服务",
    "数字设计服务",
    "技术推广服务",
    "现代金融服务",
    "电子设备制造",
    "基础软件开发",
    "应用软件开发",
    "生产服务平台",
    "生活服务平台",
    "矿山机械制造",
    "铸造机械制造",
    "工程管理服务",
    "工程设计活动",
    "电力工程施工",
    "塑料制品制造",
    "畜牧机械制造",
    "合成材料制造",
    "空调设备制造",
    "家用电器制造",
    "照明灯具制造",
    "灯用电器附件",
    "水泥制品制造",
    "金属门窗制造",
    "环境保护监测",
    "生态资源监测",
    "管道工程建筑",
    "水暖管道制造",
    "影视节目制作",
    "科技会展服务",
    "旅游会展服务",
    "文化会展服务",
    "知识产权服务",
    "金融信息服务",
    "农副食品加工",
    "焙烤食品制造",
    "糕点面包制造",
    "方便食品制造",
    "速冻食品制造",
    "营养食品制造",
    "保健食品制造",
    "冷冻饮品制造",
    "机织服装制造",
    "皮革制品制造",
    "皮革服装制造",
    "毛皮服装加工",
    "毛皮制品加工",
    "木质制品制造",
    "木质家具制造",
    "金属家具制造",
    "珠宝首饰制造",
    "体育用品制造",
    "健身器材制造",
    "建筑材料制造",
    "建筑用石加工",
    "住宅房屋建筑",
    "体育场馆建筑",
    "公路工程建筑",
    "土木工程建筑",
    "园林绿化工程",
    "公共建筑装饰",
    "公共建筑装修",
    "建筑幕墙装饰",
    "建筑幕墙装修",
    "果品蔬菜批发",
    "卫生用品批发",
    "日用杂品批发",
    "装饰物品批发",
    "日用家电批发",
    "化工产品批发",
    "五金产品批发",
    "电气设备批发",
    "通讯设备批发",
    "道路货物运输",
    "餐饮配送服务",
    "外卖送餐服务",
    "财务公司服务",
    "人力资源服务",
    "劳务派遣服务",
    "工程技术服务",
    "工程设计服务",
    "保健养生服务",
    "养生保健服务",
    "摄影扩印服务",
    "通讯设备修理",
    "办公设备维修",
    "家用电器修理",
    "日用电器修理",
    "宠物寄托收养",
    "文化艺术培训",
    "健身休闲活动",
    "体育健康服务",
    "室内娱乐活动",
    "文化活动服务",
    "旅游安保服务",
    "建筑设计服务",
    "珠宝首饰零售",
    "会议展览服务",
    "婚庆典礼服务",
    "文化艺术辅导",
    "文具用品零售",
    "网络游戏服务",
    "人工智能软件",
    "外贸综合服务",
    "冷链物流服务",
    "现代商务服务",
    "人力资源外包",
    "健康护理服务",
    "现代母婴服务",
    "新型住宿服务",
    "网络订餐服务",
    "新型餐饮服务",
    "运动休闲活动",
    "休闲观光旅游",
    "健康疗养旅游",
    "智能安防服务",
    "广告科技服务",
    "综合科技服务",
    "企业管理咨询",
    "技术培训服务",
    "体育文化发展",
    "职业技能培训",
    "人力资源顾问",
    "建筑装饰工程",
    "建筑安装施工",
    "教育科技服务",
    "教育科技发展",
    "网络信息科技",
    "网络技术服务",
    "网络科技发展",
    "网络信息技术",
    "网络科技服务",
    "网络信息服务",
    "广告设计制作",
    "广告装饰工程",
    "体育文化传播",
    "影视文化传播",
    "影视文化传媒",
    "文化传媒发展",
    "时尚文化传媒",
    "建筑安装工程",
    "建筑装饰材料",
    "汽车销售服务",
    "医疗器械销售",
    "包装材料销售",
    "金属制品销售",
    "电子科技发展",
    "电子技术服务",
    "电子信息科技",
    "商务信息咨询",
    "商务咨询服务",
    "装饰设计工程",
    "信息科技服务",
    "信息科技发展",
    "旅游信息咨询",
    "信息技术服务",
    "新房地产经纪",
    "新房地产开发",
    "餐饮企业管理",
    "餐饮管理服务",
    "餐饮经营管理",
    "餐饮投资管理",
    "健康管理咨询",
    "企业管理服务",
    "精密机械制造",
    "机械设备制造",
    "汽车技术服务",
    "生物技术服务",
    "节能环保科技",
    "环保科技发展",
    "环保技术服务",
    "节能环保技术",
    "环保科技服务",
    "环保材料科技",
    "企业咨询服务",
    "企业管理发展",
    "经济发展实业",
    "农业科技发展",
    "生态农业科技",
    "生态农业发展",
    "智能科技发展",
    "智能科技服务",
    "智能设备安装",
    "智能设备发展",
    "影视文化发展",
    "食品销售管理",
    "生物技木服务",
    "生物科技发展",
    "生物医药科技",
    "生物医字科技",
    "医药生物科技",
    "生物科技服务",
    "物业管理服务",
    "物业经营管理",
    "生活物业管理",
    "物业服务开发",
    "国际物业服务",
    "建筑设计咨询",
    "建筑装饰设计",
    "医疗科技服务",
    "医疗科技发展",
    "医疗器械科技",
    "医药科技咨询",
    "建材装饰工程",
    "建材科技发展",
    "人才咨询服务",
    "人才服务咨询",
    "人才教育管理",
    "环境资源科技",
    "日用百货销售",
    "美容美发用品",
    "软件科技服务",
    "网络技术开发",
    "机电设备安装",
    "机电安装工程",
    "机械设备安装",
    "电力设备安装",
    "国际货运代理",
    "货运代理服务",
    "金属装饰材料",
    "金属材料销售",
    "金属装饰工程",
    "汽车科技服务",
    "汽车租赁服务",
    "建筑设备租赁",
    "国际融资租赁",
    "机械设备租赁",
    "印刷机械设备",
    "酒店管理咨询",
    "医疗器械服务",
    "医疗器械技术",
    "医疗器械贸易",
    "酒店餐饮管理",
    "酒店设备工程",
    "酒店管理服务",
    "消防设备服务",
    "消防设备工程",
    "消防工程设备",
    "消防工程安装",
    "文化艺术发展",
    "空间艺术设计",
    "环境艺术设计",
    "商业地产顾问",
    "婚庆礼仪服务",
    "股权投资管理",
    "创业投资管理",
    "投资管理咨询",
    "软件技术服务",
    "医药科技服务",
    "文化艺术传播",
    "艺术设计工程",
    "艺术设计咨询",
    "商业经营管理",
    "市场经营管理",
    "市场信息咨询",
    "金融投资管理",
    "金融技术服务",
    "产业金融服务",
    "机电设备工程",
    "股权投资基金",
    "互联网安全服务",
    "化工新材料制造",
    "互联网数据服务",
    "汽车修理与维护",
    "会计及税务服务",
    "互联网信息服务",
    "互联网游戏服务",
    "互联网广告服务",
    "屠宰及肉类加工",
    "水产品冷冻加工",
    "水果和坚果加工",
    "布艺类产品制造",
    "包装装潢及印刷",
    "管道和设备安装",
    "营养保健品批发",
    "煤炭及制品批发",
    "石油及制品批发",
    "贸易经纪与代理",
    "冷藏车道路运输",
    "经济型连锁酒店",
    "房地产开发经营",
    "房地产中介服务",
    "房地产租赁经营",
    "供应链管理服务",
    "体校及体育培训",
    "歌舞厅娱乐活动",
    "互联网基金销售",
    "第三方支付服务",
    "调查与咨询服务",
    "互联网生活服务",
    "餐饮个性化定制",
    "房地产经济发展",
    "房地产管理咨询",
    "房地产开发管理",
    "互联网信息科技",
    "新型信息技术服务",
    "人工智能软件开发",
    "轨道交通相关服务",
    "海洋工程装备制造",
    "新型建筑材料制造",
    "生物医药相关服务",
    "生物化工制品制造",
    "通信系统设备制造",
    "信息技术咨询服务",
    "金属成形机床制造",
    "金属加工机械制造",
    "实验分析仪器制造",
    "旅行社及相关服务",
    "茶饮料及饮料制造",
    "运动机织服装制造",
    "文教办公用品制造",
    "日用化学产品制造",
    "防水建筑材料制造",
    "市政道路工程建筑",
    "汽车及零配件批发",
    "普通货物道路运输",
    "汽车金融公司服务",
    "机械设备经营租赁",
    "安全系统监控服务",
    "商务代理代办服务",
    "家用电子产品修理",
    "现代商品交易服务",
    "新型外卖送餐服务",
    "时尚国际文化传媒",
    "建筑装饰设计工程",
    "商务信息咨询服务",
    "餐饮企业管理咨询",
    "企业管理咨询服务",
    "食品市场经营管理",
    "生物医药科技服务",
    "医疗器械技术服务",
    "美容美发经营管理",
    "软件科技发展服务",
    "机电设备安装工程",
    "医疗器械科技服务",
    "股权投资基金管理",
    "云计算与大数据服务",
    "科技推广和应用服务",
    "环保研发与技术服务",
    "互联网科技创新平台",
    "家用制冷电器具制造",
    "建筑工程用机械制造",
    "体育用品及器材批发",
    "再生物资回收与批发",
    "可回收资源综合利用",
    "网络视频和直播服务",
    "新能源汽车销售服务",
    "互联网信息科技服务",
    "智能消费相关设备制造",
    "绿色节能建筑材料制造",
    "汽车零部件及配件制造",
    "运动休闲针织服装制造",
    "建筑工程机械经营租赁",
    "建筑工程设备经营租赁",
    "计算机和办公设备维修",
    "人力资源管理咨询服务",
    "针织或钩针编织服装制造",
    "餐饮配送及外卖送餐服务",
    "工艺美术品及收藏品零售",
    "设备工程用先进钢材制造",
    "物流信息和货运代理服务",
    "新能源汽车零部件配件制造",
    "新能源汽车充电及维修服务",
    "个性化产品设计与定制服务",
    "酒",
    "其他"
  ]
};
